import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Button } from "../button";
import { BodyCaption, TitleSmall } from "../TypographyStyle";
import { COLORS } from "../../constants/Theme";
const getTextColorBasedOnVariant = (variant) => {
    if (variant === 'light') {
        return COLORS.content.primary;
    }
    return COLORS.content.primaryInverse;
};
const TooltipStyled = styled.div `
	box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
	border-radius: 4px;
	padding: 8px;
	background-color: ${(props) => props.variant === 'light'
    ? COLORS.surface.subdued
    : COLORS.content.primary};
	color: ${(props) => getTextColorBasedOnVariant(props.variant)};
`;
const TooltipInternal = (props) => {
    var _a;
    // Todo (ashutosh) make sure that the button which is passed is inverse
    return (_jsxs(TooltipStyled, Object.assign({ variant: (_a = props.variant) !== null && _a !== void 0 ? _a : 'dark' }, { children: [props.title && (_jsx(TitleSmall, Object.assign({ color: getTextColorBasedOnVariant(props.variant), style: { marginBottom: '8px' } }, { children: props.title }))), _jsx(BodyCaption, Object.assign({ color: getTextColorBasedOnVariant(props.variant), style: { marginBottom: props.buttonProps ? '8px' : '0px' } }, { children: props.body })), props.buttonProps && _jsx(Button, Object.assign({}, props.buttonProps))] })));
};
export default TooltipInternal;
//# sourceMappingURL=TooltipInternal.js.map